module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70204/img/content-remix-post-publish/content-remix-ja.png"